module.exports = __webpack_public_path__ + "img/operation-whiteout.13f1844c.jpg";